import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, initializeAuth, connectAuthEmulator, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCxt2_0xkY2Bl8Nh0BhOiisx6K70kW1gwo",
  authDomain: "twelve-month-millionaire.firebaseapp.com",
  projectId: "twelve-month-millionaire",
  storageBucket: "twelve-month-millionaire.firebasestorage.app",
  messagingSenderId: "1031042323301",
  appId: "1:1031042323301:web:cf0fed804b0b9bc872078c",
  measurementId: "G-QT47JZJY74"
};


// Initialize Firebase

// Initialize app (singleton)
let app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Auth: native/web safe initialization with explicit persistence
let auth;
if (typeof window === 'undefined') {
  // Native/Node environment
  try {
    auth = initializeAuth(app, { persistence: undefined });
  } catch (e) {
    auth = getAuth(app);
  }
} else {
  // Web – use localStorage persistence (users stay logged in)
  // Initialize auth with persistence FIRST (synchronously if possible)
  try {
    auth = initializeAuth(app, {
      persistence: browserLocalPersistence,
    });
  } catch (e) {
    // If already initialized, get existing instance and set persistence
    auth = getAuth(app);
    setPersistence(auth, browserLocalPersistence).catch((error) => {
      console.error('Error setting auth persistence:', error);
    });
  }
}

const db = getFirestore(app);
const functions = getFunctions(app, 'us-central1');
const storage = getStorage(app);

// Auto-connect to emulators if enabled in localStorage (unless production is forced)
// CRITICAL: Never connect to emulators on production domains
const isProductionHost = typeof window !== 'undefined' && 
  window.location.hostname !== 'localhost' && 
  window.location.hostname !== '127.0.0.1';
const forceProduction = isProductionHost || (typeof window !== 'undefined' && localStorage.getItem('firebase_force_production') === 'true');

if (isProductionHost) {
  console.log('🔧 Firebase config loaded');
  console.log('✅ Firebase ready');
}

if (typeof window !== 'undefined' && localStorage.getItem('firebase_emulator_connected') === 'true' && !forceProduction) {
  try {
    // Connect to Firestore emulator
    try {
      connectFirestoreEmulator(db, '127.0.0.1', 8080);
      console.log('🔧 Auto-connected to Firestore emulator');
    } catch (e) {
      if (e.code !== 'firestore/emulator-config-failed') {
        console.warn('Firestore emulator connection warning:', e.message);
      }
    }
    
    // Connect to Auth emulator
    try {
      connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
      console.log('🔧 Auto-connected to Auth emulator');
    } catch (e) {
      if (!e.message.includes('already initialized')) {
        console.warn('Auth emulator connection warning:', e.message);
      }
    }
    
    // Connect to Functions emulator
    try {
      connectFunctionsEmulator(functions, '127.0.0.1', 5012);
      console.log('🔧 Auto-connected to Functions emulator');
    } catch (e) {
      if (!e.message.includes('already initialized')) {
        console.warn('Functions emulator connection warning:', e.message);
      }
    }
    
  } catch (error) {
    console.warn('Error auto-connecting to emulators:', error);
  }
}

export { app, auth, db, functions, storage, onAuthStateChanged };

